/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import * as Sentry from "@sentry/nextjs";
import { NextRouter } from "next/router";

let lastCall = { path: "", ts: 0 };

export function safeReplace(
  router: NextRouter,
  url: Parameters<NextRouter["replace"]>[0],
  as?: Parameters<NextRouter["replace"]>[1],
  opts: Parameters<NextRouter["replace"]>[2] = { shallow: true }
) {
  const targetPath =
    typeof url === "string" ? url : url?.pathname ?? router.pathname;
  const currentPath = router.asPath.split("#")[0];
  const now = Date.now();

  if (targetPath === currentPath && now - lastCall.ts < 500) {
    return Promise.resolve(true);
  }

  lastCall = { path: targetPath, ts: now };
  Sentry.addBreadcrumb({
    category: "navigation",
    message: `safeReplace -> ${targetPath}`,
    level: "info",
  });

  return router.replace(url as any, as as any, opts);
}

// Test-only helper to reset internal state between runs
export function __resetNavigationState() {
  lastCall = { path: "", ts: 0 };
}
